module.exports = __webpack_public_path__ + "img/confetti.2ebcbbb.png";